const getQueryString = function(query) {
  let queryString = "";
  Object.keys(query).forEach(k => {
    if (query[k] || query[k] === 0 || query[k] === false) {
      if (!queryString.includes("?")) {
        queryString += "?";
      } else {
        queryString += "&";
      }
      queryString += k + "=" + query[k];
    }
  });
  return queryString;
};

export default {
  getQueryString
};
